<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <parametros-consulta
          ref="parametrosConsulta"
          @validation-change="formValid = $event"
        />
      </v-col>

      <v-col cols="12">
        <v-btn
          id="btn-salvar-consulta-log-unitizacao"
          color="green"
          min-width="140"
          style="float: right;"
          :disabled="!formValid"
          :loading="loading"
          @click="agendarConsulta"
        >
          Agendar Consulta
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogUnitizacaoService from '@/services/LogUnitizacaoService';

export default {
  name: 'LogUnitizacaoPesquisa',

  components: {
    ParametrosConsulta: () => import('@/components/logUnitizacao/ParametrosConsulta.vue')
  },

  data() {
    return {
      formValid: false,
      loading: false
    };
  },

  methods: {
    agendarConsulta() {
      this.loading = true;

      try {
        const data = this.$refs.parametrosConsulta.exportData();

        LogUnitizacaoService.consultarChaves(data)
          .then(() => {
            this.$router.push({ name: 'Log de Unitização Histórico', query: { tab: 'consultas' } });
            this.$toast.success('Consulta agendada com sucesso. Acompanhe o processamento no histórico.', '', { position: 'topRight' });
          })
          .catch((error) => {
            const msg = error?.response?.data?.erro || error?.data?.erro || 'Erro ao agendar consulta de Log de Unitização.';
            this.$toast.error(msg, '', { position: 'topRight' });
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.message || 'Erro ao validar dados da consulta.', '', { position: 'topRight' });
      }
    }
  }
};
</script>
